<template>
  <!-- 订单管理 -->
  <div style="padding:40px">

    <el-collapse :accordion="false" style="background-color: white; margin-bottom: 10px" v-model="activeNames">
      <el-collapse-item style="padding: 0px 20px 0px 20px" name="1">
        <template slot="title">
          <p style="font-size: 14px; font-weight: 600; margin-bottom: 0px">
            <i class="header-icon el-icon-s-flag" style="color: #409eff; margin-right: 5px"></i>
            搜索设置
          </p>
        </template>
        <!-- 搜索/导出 -->
        <el-form ref="form" :inline="true" :model="form" label-width="80px" size="small" id="form1">
          <el-form-item label="订单号">
            <el-input v-model="form.order"></el-input>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.tel"></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="valuess" placeholder="请选择" multiple collapse-tags class="sel">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="valuesss" placeholder="请选择" multiple collapse-tags class="sel">
              <el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课题组">
            <el-input v-model="form.pishu_group_like" placeholder="模糊查询"></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input v-model="form.department" placeholder="部门查询"></el-input>
          </el-form-item> 
          <el-form-item label="报名方式">
            <el-select v-model="form.scene" placeholder="请选择" collapse-tags class="sel">
              <el-option key=""  label="全部报名"  value=""></el-option>
              <el-option key="1"  label="现场报名"  value="1"></el-option>
              <el-option key="2"  label="线上报名"  value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button type="primary" @click="back" v-show="id">返回会议详情</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item style="padding: 0px 20px 0px 20px" name="2">
        <template slot="title">
          <p style="font-size: 14px; font-weight: 600; margin-bottom: 0px">
            <i class="header-icon el-icon-s-flag" style="color: #409eff; margin-right: 5px"></i>
            列表设置
          </p>
        </template>
        <el-form  ref="form" :inline="true" :model="form" label-width="80px" size="small" id="form2">
          <el-form-item>
            <el-button type="primary"  @click="addorder" v-show="id">添加订单</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload class="upload-demo" action="/ac1/upload/oneFile" :on-success="fileok" :on-error="fileno" :auto-upload="true" :multiple="false" :limit="1" :on-remove="removefile" :on-exceed="overflows" accept=".xls, .xlsx" :show-file-list="true">
              <el-button slot="trigger" size="small">选择文件</el-button>
              <el-button style="margin-left: 10px" size="small" type="primary" @click="submitUpload">导入订单</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <a :href="'/ac1/conference/order/excelTmp?token='+token" target="_blank">
              <el-button v-show="id">下载订单模板</el-button>
            </a>
          </el-form-item>
          <el-form-item>
            <el-button   @click="sezi" v-show="id">导出设置</el-button>
            <el-button type="primary" @click="daochus" v-show="id">导出</el-button>
          </el-form-item>

        </el-form>
      </el-collapse-item>
    </el-collapse>


    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      v-loading="listLoading"
      id="out_table"
      :span-method="objectSpanMethod"
      :row-class-name="tableRowClassName"
      :cell-class-name="danyuan"
    >
      <el-table-column
        label="订单编号--支付时间"
        width="150"
      >
        <template slot-scope="scope">
          <div>{{scope.row.order_no}}</div>
          <div v-if="scope.row.pay_time!=null">{{scope.row.pay_time | dateformat}}</div>
          <div v-else></div>
        </template>
      </el-table-column>
      <el-table-column
                       label="发票单号"
                       prop="data_invoice"
                       width="150"

                       ></el-table-column>
      <el-table-column
        label="订单信息"
        width="300"
      >
        <template slot-scope="scope">
          <el-row :gutter="20">
           <!-- <el-col
              :span="8"
              block
            >
              <div class="grid-content bg-purple">
                <el-image
                  :src="scope.row.cover_url"
                  style="height:80px;vertical-align: middle;"
                ></el-image>
              </div>
            </el-col>-->
            <el-col :span="20">
              <div
                class="grid-content bg-purple"
                style="font-size: 12px;"
              >
                <h6>{{scope.row.name}}</h6>
                <div>报名时间：{{scope.row.enroll_start_time | dateformats}} ~ {{scope.row.enroll_end_time | dateformats}}</div>
                <div>地点：{{scope.row.city_name}}</div>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
                       label="课题组"
                       prop="pishu_group"
                       width="150"
                       ></el-table-column>
      <el-table-column
        label="规格"
        prop="ticket_type"
        width="100"
      ></el-table-column>
      <el-table-column
        label="单价"
        prop="price"
      ></el-table-column>
      <el-table-column
        label="报名信息"
        prop="meet_peoples"
      ></el-table-column>
      <el-table-column
        label="报名方式"
        prop="scene"
      ></el-table-column>
      <el-table-column
        label="电话"
        prop="tel"
      ></el-table-column>
      <el-table-column
        label="汇款方式"
        prop="offline_pay_type"
      ></el-table-column>
      <el-table-column
        label="支付方式"
        width="80"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.pay_type=='admin'">管理员</p>
          <p v-if="scope.row.pay_type=='system'">系统</p>
          <p v-if="scope.row.pay_type=='purse'">余额支付</p>
          <p v-if="scope.row.pay_type=='gold'">金币支付</p>
          <p v-if="scope.row.pay_type=='alipay'">支付宝</p>
          <p v-if="scope.row.pay_type=='wxpay'">微信支付</p>
          <p v-if="scope.row.pay_type=='unipay'">银联支付</p>
          <p v-if="scope.row.pay_type=='offline'">汇款</p>
          <p v-if="scope.row.pay_type=='paycard'">充值卡</p>
          <p v-if="scope.row.pay_type=='' || scope.row.pay_type==undefined ||scope.row.pay_type==null">无</p>
        </template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        prop="order_status"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row.order_no)"
            type="success"
          >查看详情</el-button>
          <el-button
           size="mini"
           type="primary"
           @click="reorderBtn(scope.row)"
           v-if=" scope.row.order_status=='超时关闭'"
           style="display: block;margin:7px 0px 0px 0px"
           >重新下单</el-button>
          <el-button
            size="mini"
            type="warning"
            @click="down_payment(scope.row,0)"
            v-if="scope.row.pay_type=='offline' && scope.row.order_status=='等待支付'"
            style="display: block;margin:7px 0px 0px 0px"
          >确认是否已汇款?</el-button>
          <el-button
            size="mini"
            type="warning"
            @click="down_payments(scope.row,1)"
            v-if="scope.row.pay_type=='offline' && scope.row.order_status!='等待支付'"
            style="display: block;margin:7px 0px 0px 0px"
          >编辑汇款信息</el-button>
          <el-button
            size="mini"
            type="warning"
            @click="editoffline(scope.row)"
            v-if="scope.row.pay_type!='offline' && scope.row.order_status=='等待支付'"
            style="display: block;margin:7px 0px 0px 0px"
          >线下支付状态修改</el-button>
          <el-button
            size="mini"
            type="info"
            style="display: block;margin:7px 0px 0px 0px"
            @click=" remove_payment(scope.row)"
            v-show="scope.row.order_status=='申请退款'"
          >退款</el-button>
          <!-- <el-button
            size="mini"
            type="warning"
            style="display: block;margin:7px 0px 0px 0px"
            @click=" no_payment(scope.row)"
            v-show="scope.row.order_status=='申请退款'"
          >拒绝退款</el-button> -->

        <el-button
           size="mini"
           v-if="scope.row.pay_type =='offline' && scope.row.order_status =='等待支付'"
           @click="chang_payStatus(scope.row.order_no)"
           style="display: block;margin:7px 0px 0px 0px"
           type="warning"
           >取消线下支付</el-button>
          <el-button
            style="display: block;margin:7px 0px 0px 0px"
            size="mini"
            @click="order_notes(scope.row)"
            type="primary"
          >订单备注</el-button>
          <el-button
            style="display: block;margin:7px 0px 0px 0px"
            size="mini"
            @click="showLog(scope.row)"
            type="primary"
          >修改记录</el-button>
          <el-button
            style="display: block;margin:7px 0px 0px 0px"
            size="mini"
            @click="delet(scope.row.order_no)"
            type="danger"
            v-if="scope.row.order_status != '等待支付'"
          >删除</el-button>
           <el-button
            style="display: block;margin:7px 0px 0px 0px"
            size="mini"
            @click="cancleorder(scope.row.order_no)"
            type="danger"
            v-else
          >取消订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑汇款信息弹窗 -->
    <el-dialog
      title="汇款信息"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataFor"
        ref="formno"
        label-width="120px"
      >
        <el-form-item
          label="支付方式"
          prop="offline_pay_type"
        >
          <el-select
            v-model="dataFor.offline_pay_type"
            placeholder="请选择支付类型"
            @change="huichange"
          >
            <el-option
              label="支付宝"
              value="支付宝"
            ></el-option>
            <el-option
              label="微信"
              value="微信"
            ></el-option>
            <el-option
              label="其他"
              value="其他"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="其他支付方式"
          prop="other"
        >
          <el-input
            v-model="dataFor.other"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="第三方支付单号"
          prop="offline_otherpay_no"
        >
          <el-input v-model="dataFor.offline_otherpay_no"></el-input>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="offline_note"
        >
          <el-input
            type="textarea"
            v-model="dataFor.offline_note"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="huipay()"
          >确 定</el-button>
          <el-button
            type="primary"
            @click="watepay()"
          >待录入</el-button>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="huipay()"
        >确 定</el-button>
        <el-button
          type="primary"
          @click="watepay()"
        >待录入</el-button>
        <el-button @click="remove_pay()">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置弹窗 -->
    <el-dialog
      title="设置"
      :visible.sync="sz"
    >
      <el-table
        :data="szarr"
        border
        style="width: 100%"
      >
        <el-table-column
          fixed
          prop="sort"
          label="排序"
          width="70"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
        >
        </el-table-column>
        <el-table-column
          prop="english_name"
          label="英文名称"
        >
        </el-table-column>
        <el-table-column
          prop="select"
          label="是否显示"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.select==1">显示</span>
            <span v-if="scope.row.select==0">不显示</span>
          </template>
        </el-table-column>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="editsort(scope.row)"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 保存设置弹窗 -->
    <el-dialog
      title="编辑"
      :visible.sync="szsave"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="szform"
        label-width="80px"
      >
        <el-form-item label="排序">
          <el-input
            v-model="szform.sort"
            :disabled="namedis"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-select
            v-model="szform.select"
            placeholder="请选择活动区域"
            style="width:100%"
            @change="selectchange"
          >
            <el-option
              label="不显示"
              value="0"
            ></el-option>
            <el-option
              label="显示"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            v-model="szform.name"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input
            v-model="szform.english_name"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="szsave = false">取 消</el-button>
        <el-button
          type="primary"
          @click="savesezi"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 订单备注 -->
    <el-dialog title="订单备注" :visible.sync="order_notes_visible" :close-on-click-modal="false">
      <el-form ref="order_note_ref" :model="order_notes_form_data" label-width="80px">
        <el-form-item label="备注信息" prop="order_note">
          <el-input
            type="textarea"
            v-model="order_notes_form_data.order_note"
          />
        </el-form-item>
        <el-form-item style="margin-top: 50px;">
          <el-button
            type="primary"
            @click="order_note_submit()"
          >提交</el-button>
          <el-button
            type="none"
            @click="order_note_cancel()"
          >取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分页 -->
    <div style="width:100%;text-align: center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        background
        :total="total"
        style="margin-top:20px;"
      ></el-pagination>
    </div>

    <!--添加订单弹框-->
      <el-dialog
        title="添加订单"
        :visible.sync="addOrderDialog"
        v-if="addOrderDialog"
        width="30%"
        :close-on-click-modal="true"
        class="maxWidthDia"
      >
        <iframe :src="'/conferenceI/#/addOrder01/'+form.ids" style="height:65vh;width:100%;max-width:375px;" frameborder="0"></iframe>
      </el-dialog>

      <el-dialog :visible.sync="operationLogVisible" title="订单操作记录" width="1150px" destroy-on-close>
        <el-table :data="operationLogs" >
          <el-table-column label="行为" prop="ope_type" width="auto" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ope_type }} -- {{ scope.row.type_str }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="create_time" width="auto" align="center" >
            <template slot-scope="scope">
              <span>{{ scope.row.create_time | dateformat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="修改人员姓名" prop="member_name" width="auto" align="center"/>
          <el-table-column label="修改明细" prop="create_time" width="auto" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <div style="text-align: left;">
                <div style="background-color: rgba(#000, 0.3);white-space: nowrap;">更改前：{{ scope.row.origin_data }}</div>
                <div style="white-space: nowrap;">更改后：{{ scope.row.after_data }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="修改备注" prop="ask_notes" width="auto" align="center" show-overflow-tooltip/>
          <el-table-column label="要求修改人姓名" prop="ask_member_name" width="auto" align="center"/>
          <el-table-column label="要求修改人电话" prop="ask_member_phone" width="auto" align="center"/>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="operationPagination.count " @current-change="handleLogPageChange"></el-pagination>
      </el-dialog>
  </div>
</template>
<style>
.el-table .warning-row {
  background: #ecf2fc;
}

.el-table .success-row {
  background: white;
}
</style>
<script>
import moment from "moment"; //时间处理
import { formatRowspanAndColspan } from "../../directives/down_excil"; /* 合并单元格 */

export default {
  name: "TheOrderManagement",
  data () {
    return {
      szsave: false,
      sz: false,
      namedis: false,
      szarr: [],
      szform: {
        id: "",
        sort: "",
        select: "",
        name: "",
        english_name: ""
      },
      dataFor: {
        offline_pay_type: "",
        offline_otherpay_no: "",
        offline_note: "",
        typepp: "",
        other: "",
      },
      order_notes_visible: false,
      order_notes_form_data: {
        order_no: '',
        old_order_note: '',
        order_note: ''
      },
      disabled: true,
      options: [
        {
          value: "waitting",
          label: "等待支付",
        },
        {
          value: "finished",
          label: "订单完成",
        },
        {
          value: "cancel",
          label: "取消",
        },
        {
          value: "timeout",
          label: "超时关闭",
        },
        {
          value: "delete",
          label: "订单删除",
        },
        {
          value: "refund",
          label: "退款成功",
        },
        {
          value: "application",
          label: "申请退款",
        },
        {
          value: "reject",
          label: "退款驳回",
        },
      ],
      optionss: [
        {
          value: "purse",
          label: "免费用户",
        },
        {
          value: "alipay",
          label: "支付宝",
        },
        {
          value: "wxpay",
          label: "微信支付",
        },
        {
          value: "offline",
          label: "汇款",
        },
      ],
      valuess: [],
      valuesss: [],
      centerDialogVisible: false,
      form: {
        name: "",
        ids: "",
        order: "",
        tel: "",
        pishu_group:'',//课题组精准查询
        pishu_group_like:'',//课题组模糊查询
        department:'',//部门查询
        scene:'',//报名方式
      },
      tableData: [],
      list: [],
      order_no: "",
      total: 0,
      pageSize: 8,
      listLoading: false,
      currentPage: 1,
      id: false,
      file_url:'',//导入文件地址
      activeNames:['1','2'],
      token:'',
      addOrderDialog:false,//添加订单status

      operationLogVisible: false,
      operationPagination: {
        id: null,
        page: 1,
        pagesize: 10
      },
      operationLogs: [],
    };
  },
  created () { },
  mounted () {
    this.token = this.$cookies.get("member_token");
    if (this.$route.query.id != undefined)
    {
      this.form.ids = this.$route.query.id;
      this.id = true;
      this.showTable(this.currentPage, this.pageSize);
      this.getseziarr()
    } else
    {
      this.form.ids = "";
      this.showTable(this.currentPage, this.pageSize);
    }
  },

  methods: {
    //打开添加订单
    addorder(){
      this.addOrderDialog = true;
    },
    /* 订单导入 */
    submitUpload () {
      var _this = this;
      let url = _this.APIurl.API.api.addExcel;
      var params = {
        file_url: _this.file_url,
        c_id:_this.form.ids
      };
      if (_this.file_url == "")
      {
        _this.$message({
          type: "warning",
          message: "请选择文件",
          duration: 1000,
        });
      } else
      {
        _this.$post(url, params).then((res) => {
          if (res.code == 1)
          {
            _this.$message({
              message: "成功",
              type: "success",
              duration: 1000,
            });
            _this.file_url = "";
            window.location.reload();
          } else
          {
            _this.$message({
              message: res.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      }
    },
    /* 导入成功 */
    fileok (response, file, fileList) {
      var _this = this;

      if (response.code == 1)
      {
        _this.file_url = response.posts.file_url;
       /* _this.$message({
          type: "success",
          message: "导入成功",
          duration: 1000,
        });*/
      } else
      {
        _this.$message({
          type: "error",
          message: response.msg,
          duration: 1000,
        });
      }
    },
    /* 导入失败 */
    fileno (err, file, fileList) {
      console.log(err);
    },
    /* 移除文件 */
    removefile () {
      var _this = this;
      _this.file_url = "";
    },
    /* 导入时超出个数 */
    overflows (files, fileList) {
      var _this = this;
      _this.$message({
        type: "warning",
        message: "超出限制数",
        duration: 1000,
      });
    },
    /* 修改线下支付 */
    editoffline (row) {
      var _this = this
      var url = "/ac1/conference/order/changeToOffline";
      var params = {
        order_no: row.order_no,
      };
      _this.$confirm('确定要修改为线下支付吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '修改成功!',
              duration: 1000
            });
            this.showTable(this.currentPage, this.pageSize);
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })

      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /* 是否选中 */
    selectchange (val) {
      var _this = this
      if (val == "0")
      {
        _this.namedis = true
        _this.szform.sort = 0
      } else
      {
        _this.namedis = false
      }
    },
    /* 设置 */
    sezi () {
      this.sz = true
    },
    editsort (objrow) {
      var _this = this
      _this.szform.id = _this.form.ids
      _this.szform.sort = objrow.sort
      _this.szform.select = String(objrow.select)
      _this.szform.name = objrow.name
      _this.szform.english_name = objrow.english_name
      if (objrow.sort == 0)
      {
        _this.namedis = true
      } else
      {
        _this.namedis = false
      }
      _this.szsave = true
    },
    /* 保存设置 */
    savesezi () {
      var _this = this
      var newarr = _this.szarr
      for (let i = 0; i < newarr.length; i++)
      {
        if (newarr[i].name == _this.szform.name)
        {
          newarr[i].sort = _this.szform.sort
          newarr[i].select = _this.szform.select
        }
      }
      var url = "/ac1/conference/excel/save"
      var params = {
        id: _this.szform.id,
        data: newarr
      }
      _this.$post(url, params).then(res => {
        if (res.code == 1)
        {
          _this.$message({
            type: 'success',
            message: '保存成功!',
            duration: 1000
          })
          _this.szsave = false
          _this.getseziarr()
        } else
        {
          _this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(function (error) {
        _this.$message({
          type: 'danger',
          message: error
        })
      })
    },
    getseziarr () {
      var _this = this
      if (_this.form.ids != "")
      {
        var url = "/ac1/conference/excel/list"
        var params = {
          id: _this.form.ids
        }
        _this.$get(url, params).then(res => {
          console.log(res);
          if (res.code == 1)
          {
            _this.szarr = res.posts
          }
        })
      }
    },
    //重新下单
    reorderBtn(item){
      var _this = this;

      _this.$confirm('此操作将重新下单该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var url = _this.APIurl.API.api.reorder;
        var params = {
          order_no:item.order_no
        }
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '下单成功!',
              duration: 1000
            })
            window.location.reload();
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        }).catch(function (error) {
          _this.$message({
            type: 'danger',
            message: error
          })
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消重新下单',
          duration: 1000
        });
      });




    },
    // 订单备注
    order_notes(item){
      console.log('item', item)
      this.order_notes_form_data.order_no = item.order_no
      this.order_notes_form_data.old_order_note = item.order_remark
      this.order_notes_form_data.order_note = item.order_remark
      this.order_notes_visible = true
    },
    order_note_submit(){
      this.$post('/ac1/conference/orderremark', {
        order_no: this.order_notes_form_data.order_no,
        order_mark: this.order_notes_form_data.order_note
      })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '保存成功!',
              duration: 1000
            });
            this.order_notes_visible = false
            this.order_notes_form_data.order_no = ''
            this.order_notes_form_data.order_note = ''
            this.showTable(this.currentPage, this.pageSize);
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })

    },
    order_note_cancel(){
      if(this.order_notes_form_data.order_note != '' && this.order_notes_form_data.order_note != this.order_notes_form_data.old_order_note){
        this.$confirm('是否确认放弃当前已编写备注？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.order_notes_visible = false
          this.order_notes_form_data.order_no = ''
          this.order_notes_form_data.order_note = ''
        })
      } else {
        this.order_notes_visible = false
        this.order_notes_form_data.order_no = ''
        this.order_notes_form_data.order_note = ''
      }
    },

    handleFetchOperationLogsData(){
      this.$get(this.APIurl.API.api.operationLog, this.operationPagination).then(res => {
        this.operationPagination.count = res.posts.count
        this.operationLogs = res.posts.list
        this.operationLogVisible = true
      })
    },

    // 修改记录
    showLog(item){
      if(this.operationPagination.id != item.id){
        this.operationPagination = {
          count: 0,
          page: 1,
          pagesize: 10,
          id: item.id,
        }
      }
      this.handleFetchOperationLogsData()
    },
    handleLogPageChange(page){
      this.operationPagination.page = page
      this.handleFetchOperationLogsData()
    },

    /* 删除订单 */
    delet (order) {
      var _this = this
      var url = "/ac1/conference/ConfOrder/delete"
      var params = {
        order_no: order
      }
      _this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delet(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '删除成功!',
              duration: 1000
            });
            _this.showTable(_this.currentPage, _this.pageSize);
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 1000
        });
      });
    },
    //取消订单
    cancleorder(order){
      var _this = this
      var url = "/ac1/conference/cancleorder"
      var params = {
        order_no: order
      }
      _this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$get(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '取消成功!',
              duration: 1000
            });
            _this.showTable(_this.currentPage, _this.pageSize);
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })
      }).catch(() => {
        
      });
    },
    /* 隔行变色表格 */
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 1)
      {
        return "success-row";
      } else
      {
        return "warning-row";
      }
      return "";
    },
    /* 表格第一行第九行变白色背景 */
    danyuan ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex == 9)
      {
        return "success-row";
      }
    },
    /* 导出 */
    daochus () {
      window.location.href =
        "/ac1/conference/exportOrderList?id=" + this.form.ids + "&order_status=" + this.valuess +
        "&member_token=" +
        this.$cookies.get("member_token") +
        "&conferenceId=" + sessionStorage.getItem("conferenceId");
    },
    /* 合并单元格 */
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // columnIndex代表列，合并表格
      const newArr = formatRowspanAndColspan(this.tableData, "order_no");
      if (columnIndex === 0)
      {
        const num = newArr[rowIndex].num;
        if (num > 1)
        {
          return {
            rowspan: num,
            colspan: 1,
          };
        } else if (num < 1)
        {
          return {
            rowspan: 1,
            colspan: num,
          };
        } else
        {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      } else if (columnIndex === 9)
      {
        const num = newArr[rowIndex].num;
        if (num > 1)
        {
          return {
            rowspan: num,
            colspan: 1,
          };
        } else if (num < 1)
        {
          return {
            rowspan: 1,
            colspan: num,
          };
        } else
        {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      }
    },
    /* back */
    back () {
      this.$router.push({
        path: "/admin/MeetingDetails",
        query: {
          editId: this.$route.query.id,
          cur: this.$route.query.cur,
        },
      });
      this.id = false;
    },
    /* 搜索提交 */
    onSubmit (currentPage, pageSize) {
      var _this = this;
      _this.currentPage = 1
      _this.showTable(_this.currentPage, _this.pageSize);
    },
    /* 初始化数据 */
    showTable (currentPage, pageSize) {
      var _this = this;
      _this.listLoading = true;
      _this.tableData = [];
      let url = "/ac1/conference/order/list";
      var params = {
        page: currentPage,
        pagesize: pageSize,
        order_no: _this.form.order,
        id: _this.form.ids,
        name: _this.form.name,
        order_status: _this.valuess,
        pay_type: _this.valuesss,
        phone: _this.form.tel,
        pishu_group:_this.form.pishu_group,
        pishu_group_like:_this.form.pishu_group_like,
        department:_this.form.department,
        scene:_this.form.scene,
      };
      _this.$get(url, params).then((res) => {
        _this.listLoading = false;
        var list = res.posts.list; /* 所有订单 arr*/
        for (let i = 0; i < list.length; i++)
        {
          /* 主会议 */
          if (list[i].conference != [])
          {
            var list_conference = list[i].conference; /* 主会议 obj*/
            var order_list = list[i].order_info; /* 订单信息 obj*/
            var list_conferences =
              list[i].conference.conference; /* 主会议信息 obj*/
            // if (list_conferences === undefined) {
            //   list_conferences = [];
            // }
            var data_list = list[i].conference.data; /* 会议门票，人  arr*/
            // if (data_list === undefined) {
            //   data_list = [];
            // }
            var data_invoice =  list[i].invoice.invoice_no;
            for (let m = 0; m < data_list.length; m++)
            {
              var list_conference_ticket =
                data_list[m].ticket; /* 主会议门票 obj*/
              var list_conference_member =
                data_list[m].member; /* 主会议用户 arr*/
              // if (list_conference_member === undefined) {
              //   list_conference_member = [];
              // }
              let member_name = []; /* 会议用户姓名 */

              for (let l = 0; l < list_conference_member.length; l++)
              {
                // member_name.push(list_conference_member[l].name);
                // var m_name = member_name.toString();
                var m_name = list_conference_member[l].name;

                var obj = {
                  id: order_list.id,
                  // order_info: JSON.parse(order_list.order_info),
                  order_no: order_list.order_no /* 订单号 */,
                  order_remark: order_list.order_remark /* 订单备注 */,
                  pay_type: order_list.pay_type /* 支付类型 */,
                  tel: list_conference_member[l].tel,
                  offline_pay_type: order_list.offline_pay_type /* 汇款方式 */,
                  is_free: list_conference_member[l].is_free /* 是否免费用户 */,
                  pay_time: order_list.pay_time /* 支付时间 */,
                  order_status: order_list.order_status_str /* 订单状态 */,
                  order_pay: order_list.pay_time /* 支付时间 */,
                  ticket_type: list_conference_ticket.name /* 门票类型 */,
                  price: order_list.amount /* 单价 */,
                  name: list_conference_ticket.name /* 会议名称 */,
                  city_name: list_conferences.city_name /* 城市 */,
                  cover_url: list_conferences.cover_url /* 图片 */,
                  meet_peoples: m_name /* 用户姓名 */,
                  start_time: list_conferences.start_time /* 会议开始时间 */,
                  end_time: list_conferences.end_time /* 会议结束时间 */,
                  enroll_start_time:
                    list_conferences.enroll_start_time /* 报名开始时间 */,
                  enroll_end_time:
                    list_conferences.enroll_end_time/* 报名结束时间 */,
                  data_invoice:data_invoice,
                  pishu_group:order_list.pishu_group,
                  scene:order_list.scene == 1?'现场报名':'线上报名',//报名方式
                };
                _this.tableData.push(obj);
              }
            }
          }
          if (list[i].parallel != [])
          {
            var list_parallel = list[i].parallel; /* 平行会议  arr*/
            // console.log(list_parallel);
            for (let bc = 0; bc < list_parallel.length; bc++)
            {
              var list_parallel_conference =
                list_parallel[bc].conference; /*平行会议信息 obj*/
              console.log(list_parallel_conference);

              var list_parallel_data =
                list_parallel[bc].data; /* 平行会议门票，用户信息 arr*/
              for (let m = 0; m < list_parallel_data.length; m++)
              {
                var list_conference_tickets =
                  list_parallel_data[m].ticket; /* 平行会议门票 obj*/
                var list_conference_members =
                  list_parallel_data[m].member; /* 平行会议用户 arr*/
                // if (list_conference_members == "") {
                //   list_conference_members = [];
                // }
                let member_names = []; /* 平行会议用户姓名 */
                for (let l = 0; l < list_conference_members.length; l++)
                {
                  // member_names.push(list_conference_members[l].name);
                  // var m_names = member_names.toString();
                  var m_names = list_conference_members[l].name;
                  var objs = {
                    order_no: order_list.order_no /* 订单号 */,
                    pay_time: order_list.pay_time,
                    tel: list_conference_members[l].tel,
                    pay_type: order_list.pay_type /* 支付类型 */,
                    offline_pay_type:
                      order_list.offline_pay_type /* 汇款方式 */,
                    order_status: order_list.order_status_str /* 订单状态 */,
                    ticket_type: list_conference_tickets.name /* 门票类型 */,
                    order_pay: order_list.pay_time /* 支付时间 */,
                    price: order_list.amount /* 单价 */,
                    name: list_conference_tickets.name /* 会议名称 */,
                    city_name: list_parallel_conference.city_name /* 城市 */,
                    cover_url: list_parallel_conference.cover_url /* 图片 */,
                    meet_peoples: m_name /* 用户姓名 */,
                    start_time:
                      list_parallel_conference.start_time /* 会议开始时间 */,
                    end_time:
                      list_parallel_conference.end_time /* 会议结束时间 */,
                    enroll_start_time:
                      list_parallel_conference.enroll_start_time /* 报名开始时间 */,
                    enroll_end_time:
                      list_parallel_conference.enroll_end_time /* 报名结束时间 */,
                  };
                }
                _this.tableData.push(objs);
              }
            }
          }
        }
        _this.total = res.posts.count;
      });
    },
    /*查看详情 */
    handleEdit (order_no) {
      this.$router.push({
        path: "/admin/Orderdetails",
        query: {
          id: order_no,
        },
      });
    },
    /* 汇款 */
    down_payment (row, i) {
      var _this = this;
      _this.order_no = row.order_no;
      _this.dataFor.typepp = i;
      _this.centerDialogVisible = true;
    },
    /* 编辑汇款 */
    down_payments (row, i) {
      var _this = this;
      _this.order_no = row.order_no;
      _this.dataFor.typepp = i;
      var url = "/ac1/conference/orderDetail";
      var params = {
        order_no: row.order_no,
      };
      _this.$get(url, params).then((res) => {
        console.log(res);
        if (res.code == 1)
        {
          var objs = res.posts.order_info;
          _this.dataFor.offline_record_status = objs.offline_record_status;
          _this.dataFor.offline_otherpay_no = objs.offline_otherpay_no;
          _this.dataFor.offline_note = objs.offline_note;
          if (
            objs.offline_pay_type == "支付宝" ||
            objs.offline_pay_type == "微信" ||
            objs.offline_pay_type == "管理员" ||
            objs.offline_pay_type == "余额支付" ||
            objs.offline_pay_type == "银联支付" ||
            objs.offline_pay_type == "充值卡"
          )
          {
            _this.dataFor.offline_pay_type = objs.offline_pay_type;
            _this.disabled = true;
          } else
          {
            _this.dataFor.offline_pay_type = "其他";
            _this.dataFor.other = objs.offline_pay_type;
            _this.disabled = false;
          }
        }
      });
      _this.centerDialogVisible = true;
    },
    /* 监听选择汇款方式 */
    huichange (val) {
      var _this = this;
      if (val == "其他")
      {
        _this.disabled = false;
      } else
      {
        _this.disabled = true;
        _this.dataFor.other = "";
      }
    },
    /* 确定汇款 */
    huipay () {
      var _this = this;
      let url = "/ac1/conference/offlinePay";
      if (_this.dataFor.offline_pay_type == "其他")
      {
        _this.dataFor.offline_pay_type = _this.dataFor.other;
      }
      let params = {
        order_no: _this.order_no,
        offline_pay_type: _this.dataFor.offline_pay_type,
        offline_record_status: "2",
        offline_otherpay_no: _this.dataFor.offline_otherpay_no,
        offline_note: _this.dataFor.offline_note,
        type: _this.dataFor.typepp,
      };
      _this.$post(url, params).then((res) => {
        if (res.code == 1)
        {
          _this.$message({
            type: "success",
            message: "成功",
            duration: 1000,
          });
          _this.$nextTick(() => {
            _this.$refs.formno.resetFields();
          });
          _this.centerDialogVisible = false;
          _this.showTable(_this.currentPage, _this.pageSize);
        } else
        {
          var a = res.msg;
          _this.$message({
            type: "warning",
            message: a,
            duration: 1000,
          });
        }
      });
    },
    /* 待录入汇款 */
    watepay () {
      var _this = this;
      this.$confirm(
        "您的信息未填写完整是否确认保存？如若保存，后续请及时不全信息.",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let url = "/ac1/conference/offlinePay";
          if (_this.dataFor.offline_pay_type == "其他")
          {
            _this.dataFor.offline_pay_type = _this.dataFor.other;
          }
          let params = {
            order_no: _this.order_no,
            offline_pay_type: _this.dataFor.offline_pay_type,
            offline_record_status: "1",
            offline_otherpay_no: _this.dataFor.offline_otherpay_no,
            offline_note: _this.dataFor.offline_note,
            type: _this.dataFor.typepp,
          };
          _this.$post(url, params).then((res) => {
            if (res.code == 1)
            {
              _this.$message({
                type: "success",
                message: "成功",
                duration: 1000,
              });
              _this.$nextTick(() => {
                _this.$refs.formno.resetFields();
              });
              _this.centerDialogVisible = false;
              _this.showTable(_this.currentPage, _this.pageSize);
            } else
            {
              var a = res.msg;
              _this.$message({
                type: "warning",
                message: a,
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /* 取消汇款 */
    remove_pay () {
      var _this = this;
      _this.$nextTick(() => {
        _this.$refs.formno.resetFields();
      });
      _this.centerDialogVisible = false;
    },
    /* 退款 */
    remove_payment (row) {
      var _this = this;
      _this
        .$confirm("是否要退款？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let url = "/ac1/conference/refundSuccess";
          let params = {
            order_no: row.order_no,
            type: "0",
          };
          _this.$post(url, params).then((res) => {
            if (res.code == 1)
            {
              _this.$message({
                type: "success",
                message: "恭喜你,退款成功！",
                duration: 1000,
              });
              _this.showTable(_this.currentPage, _this.pageSize);
            } else
            {
              var a = res.msg;
              _this.$message({
                type: "warning",
                message: a,
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消",
            duration: 1000,
          });
        });
    },
    /*拒绝退款*/
    no_payment (row) {
      var _this = this;
      _this
        .$prompt("请输入拒绝退款理由", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(({ value }) => {
          let url = "/ac1/conference/refundSuccess";
          let params = {
            order_no: row.order_no,
            type: "1",
            note: value,
          };
          _this.$post(url, params).then((res) => {
            if (res.code == 1)
            {
              _this.$message({
                type: "success",
                message: "成功 ",
                duration: 1000,
              });
              _this.showTable(_this.currentPage, _this.pageSize);
            } else
            {
              _this.$message({
                type: "info",
                message: res.msg,
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消",
            duration: 1000,
          });
        });
    },
    //修改为待支付
    chang_payStatus(order_no){
      var _this = this;
      _this
        .$confirm("是否确认修改？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
        let url = _this.APIurl.API.api.offlineToWaiting;
        let params = {
          order_no: order_no,
        };
        _this.$post(url, params).then((res) => {
          if (res.code == 1)
          {
            _this.$message({
              type: "success",
              message: "修改成功 ",
              duration: 1000,
            });
            _this.showTable(_this.currentPage, _this.pageSize);
          } else
          {
            _this.$message({
              type: "info",
              message: res.msg,
              duration: 1000,
            });
          }
        });
      })
        .catch(() => {
        _this.$message({
          type: "info",
          message: "已取消",
          duration: 1000,
        });
      });
    },
    /*点击上一页,下一页 */
    handleSizeChange: function (size) {
      this.pageSize = size;
      console.log(this.pageSize); //每页下拉显示数据
      this.showTable(this.currentPage, this.pageSize); /* 请求数据 */
    },
    /* 点击分页下标 */
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
      this.showTable(this.currentPage, this.pageSize); /* 请求数据 */
    },
  },
};
</script>

<style scoped>
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #101111 !important;
}
 /deep/ .el-collapse-item__content{
    padding-bottom: 15px;
  }
.el-form-item {
  margin-bottom: 0px;
}

.el-table .warning-row {
  background-color: blue;
}
#form1 .el-input {
  width: 110px !important;
}
#form1 .el-select {
  width: 110px;
}
  /deep/   .maxWidthDia .el-dialog{
    max-width: 400px !important;
    min-width: 400px !important;
  }
</style>
